module.exports = __webpack_public_path__ + "static/media/grabients.1bdf9b56.sketch";


//////////////////
// WEBPACK FOOTER
// ./src/assets/grabients.sketch
// module id = 241
// module chunks = 0